exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.protocol-wrap .titleBox div {\n  font-family: PingFangSC-Medium;\n  font-size: 0.8rem;\n  color: #333333;\n  letter-spacing: 0;\n  text-align: center;\n  font-weight: bold;\n}", ""]);

// exports
